import React from "react";
import { Link } from "react-router-dom";
import { CalendarClock, ArrowLeft } from "lucide-react";
import { COMPANY, LEGAL_LINKS } from "@/lib/company";

export function LegalLayout({ title, updated = "Haziran 2026", children }) {
  return (
    <div className="min-h-screen grain-bg" data-testid="legal-page">
      <header className="sticky top-0 z-40 backdrop-blur-xl bg-background/80 border-b border-border">
        <div className="max-w-3xl mx-auto px-5 h-16 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2" data-testid="legal-brand-logo">
            <div className="w-8 h-8 rounded-lg bg-primary flex items-center justify-center">
              <CalendarClock className="w-5 h-5 text-primary-foreground" />
            </div>
            <span className="font-display font-bold text-xl">{COMPANY.brand}</span>
          </Link>
          <Link to="/" className="flex items-center gap-1.5 text-sm text-muted-foreground hover:text-foreground transition-colors" data-testid="legal-back-home">
            <ArrowLeft className="w-4 h-4" /> Ana Sayfa
          </Link>
        </div>
      </header>

      <main className="max-w-3xl mx-auto px-5 py-12">
        <h1 className="text-3xl sm:text-4xl font-bold tracking-tight">{title}</h1>
        <p className="text-sm text-muted-foreground mt-2">Son güncelleme: {updated}</p>
        <div className="mt-8 space-y-6 text-[15px] leading-relaxed text-foreground/90 [&_h2]:text-xl [&_h2]:font-semibold [&_h2]:mt-8 [&_h2]:mb-1 [&_h2]:text-foreground [&_ul]:list-disc [&_ul]:pl-6 [&_ul]:space-y-1.5 [&_a]:text-primary [&_a]:underline">
          {children}
        </div>
      </main>

      <footer className="border-t border-border py-8">
        <div className="max-w-3xl mx-auto px-5 text-sm text-muted-foreground">
          <div className="flex flex-wrap gap-x-5 gap-y-2 mb-4">
            {LEGAL_LINKS.map((l) => (
              <Link key={l.to} to={l.to} className="hover:text-foreground transition-colors" data-testid={`legal-footer-link-${l.to.replace("/", "")}`}>{l.label}</Link>
            ))}
          </div>
          <p>{COMPANY.legalName} · {COMPANY.brand} — {COMPANY.websiteLabel}</p>
        </div>
      </footer>
    </div>
  );
}

export function CompanyInfoTable() {
  const rows = [
    ["Ünvan", COMPANY.legalName],
    ["Adres", COMPANY.address],
    ["Telefon", COMPANY.phone],
    ["E-posta", COMPANY.email],
    ["Vergi Dairesi", COMPANY.taxOffice],
    ["Vergi Numarası", COMPANY.taxNumber],
    ["Web Sitesi", COMPANY.websiteLabel],
  ];
  return (
    <div className="rounded-2xl border border-border bg-card overflow-hidden" data-testid="company-info-table">
      <dl className="divide-y divide-border">
        {rows.map(([k, v]) => (
          <div key={k} className="flex flex-col sm:flex-row gap-1 sm:gap-4 px-5 py-3.5">
            <dt className="w-full sm:w-44 shrink-0 text-sm font-medium text-muted-foreground">{k}</dt>
            <dd className="text-sm font-medium">{v}</dd>
          </div>
        ))}
      </dl>
    </div>
  );
}
